import React, { useState } from 'react';
//LIBRARIES
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux';
import { useForm, Controller } from 'react-hook-form'
//REDUX
import { setModal, selectModal } from '../../../redux/modalSlice';
// HELPERS
import { frequencyOptions, payOnHolidayOptions, dayOfWeekOptions } from '../../../helpers/loanCalcHelper';

export default function AdjustScheduleModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
  };

  const [selectedHowOftenPaid, setSelectedHowOftenPaid] = useState("");
  const [selectedGetPaidDay, setSelectedGetPaidDay] = useState("");
  const [selectedPreviousNextBusinessDay, setSelectedPreviousNextBusinessDay] = useState("");
  const [saving, setSaving] = useState(false);

  const {
    register, handleSubmit, control, setValue, setError, formState: { errors }, watch, reset, clearErrors } = useForm();

  const handleCreateSchedule = (event) => {
    event.preventDefault();
    clearErrors('payroll_info');
    clearErrors('payment_schedule');
    handleSubmit(onSubmit)();
    dispatch(setModal({ is_active: false }));
  };

  const onSubmit = (formData) => {
    console.log('formData', formData);
  }

  return modal.is_active && modal.type === 'adjust_schedule' ? (
    <div className="modal is-active adjust-schedule-modal">
      <div className="modal-background"></div>
      <div className="modal-card column is-3">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            Adjust Schedule
          </p>
          <button className="delete" aria-label="close" onClick={handleCancel}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ height: "320px", overflow: 'hidden' }}
        >
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">How often do you get paid?</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <Controller
                    name="frequency"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={frequencyOptions}
                        menuPortalTarget={document.querySelector('.adjust-schedule-modal')}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 1001 }),
                        }}
                        onChange={(e) => {
                          setSelectedHowOftenPaid(e);
                          setValue('how_often_paid', e.value);
                        }}
                        value={selectedHowOftenPaid}
                      />
                    )}
                  />
                </div>
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.how_often_paid && <span>{errors.how_often_paid.message}</span>}
                </p>
              </div>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">What day do you get paid?</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <Controller
                    name="frequency"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={dayOfWeekOptions}
                        onChange={(e) => {
                          setSelectedGetPaidDay(e);
                          setValue('get_paid_day', e.value);
                        }}
                        menuPortalTarget={document.querySelector('.adjust-schedule-modal')}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 1001 }),
                        }}
                        value={selectedGetPaidDay}
                      />
                    )}
                  />
                </div>
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.get_paid_day && <span>{errors.get_paid_day.message}</span>}
                </p>
              </div>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">
                If your payday fails on a holiday or weekend, do you get paid the previous business day or next business day?
              </label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <Controller
                    name="frequency"
                    control={control}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={payOnHolidayOptions}
                        onChange={(e) => {
                          setValue('frequency', e.value);
                          setSelectedPreviousNextBusinessDay(e);
                        }}
                        value={selectedPreviousNextBusinessDay}
                      />
                    )}
                  />
                </div>
                <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                  {errors.frequency && <span>{errors.frequency.message}</span>}
                </p>
              </div>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">What is the date of your next payday?</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <input
                    name="next_payment_date"
                    className="input is-small"
                    type="date"
                    // placeholder="Origination Date"
                    {...register('next_payment_date', { required: true })}
                  />
                  <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                    {errors.next_payment_date && <span>{errors.next_payment_date.message ? errors.next_payment_date.message : "Next Payment Date is required"}</span>}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">Number of Installments</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <input
                    name="number_of_payments"
                    className="input is-small"
                    type="number"
                    // placeholder="Number of Installments/Payments"
                    {...register('number_of_payments', { required: true })}
                  />
                  <p className="has-text-danger is-size-7 lox-capitalize-first-letter">
                    {errors.number_of_payments && <span>{errors.number_of_payments.message ? errors.number_of_payments.message : "Number of Payments is required"}</span>}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleCancel}>Cancel</button>
            <button type="submit" disabled={saving && 'disabled'} className="button is-link is-small" onClick={handleCreateSchedule}>Submit</button>
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
